export default __webpack_public_path__ + "static/media/teachers_guide_image.a21e683a.jpg";